export enum BlogActionItemEnum {
  Edit = 'edit_blog',
}

export enum BlogContentTabEnum {
  Posts = 'posts',
  Categories = 'categories',
}

export enum BlogPostFilterEnum {
  AllPosts = 'all_posts',
  ActivePosts = 'active_posts',
  InactivePosts = 'inactive_posts',
}

export enum BlogPostStatusEnum {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Published = 'published',
}

export enum BlogPostActionItemEnum {
  Settings = 'settings',
  Duplicate = 'duplicate',
  Schedule = 'schedule',
  Activate = 'activate',
  Delete = 'delete',
}

export enum BlogCategoryActionItemEnum {
  Settings = 'settings',
  Delete = 'delete',
}
